import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_ORDINARY_FOR_ORDINARY_QUERY = graphql(/* GraphQL */ `
	query discountOrdinaryForOrdinary($hotelID: String!, $discountId: String!) {
		discountOrdinary(hotelID: $hotelID, discountID: $discountId) {
			name
			hotelID
			discountID
			discountCode
			inSale
			isPlanDiscountEligible
			isRoomDiscountEligible
			isOptionDiscountEligible
			isAdditionalFeeDiscountEligible
			description
			isUncancelable
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			staticTargetType
			staticTermType
			discountType
			ratio
			resourceLowestPrice {
				currencyType
				amount
			}
			discountPriceTotalLimit {
				currencyType
				amount
			}
			static {
				currencyType
				amount
			}
		}
	}
`);
